import { Add, ProfileAdd } from 'iconsax-react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useOnClickOutside } from 'usehooks-ts';
import CreateGroup from '@/assets/images/icons/create-group.svg?react';
import ProfileAdd2 from '@/assets/images/icons/profile-add-multiple.svg?react';
import { useUserHints } from '@/hooks/use-user-platform';
import ROUTES from '@/routes';
import cn from '@/utils/merge-class-names';

interface Props {
  className?: string;
}

export default function AppHeaderMenu({ className }: Props) {
  const { t } = useTranslation();
  const {
    hints: { osType },
  } = useUserHints();
  const detailRef = useRef<HTMLDetailsElement>(null);

  useOnClickOutside(detailRef, () => detailRef.current?.removeAttribute('open'));

  return (
    <details
      key='app-header-menu'
      className={cn('dropdown dropdown-end', className)}
      ref={detailRef}>
      <summary
        tabIndex={0}
        role='button'
        className='btn btn-square btn-ghost mode-embedded:btn-sm mode-embedded:text-primary-content layout-mini:text-inherit layout-compact:text-inherit'>
        <Add className='size-6' />
      </summary>

      <ul className='menu dropdown-content z-50 w-full min-w-40 rounded-lg bg-neutral-0 shadow-lg text-base-content'>
        <li className='w-full'>
          <Link
            to={ROUTES.CONTACT.REQUEST.$path()}
            className='flex w-full items-center gap-2'>
            <ProfileAdd className='size-5' />
            {t('conversation.list.menu.add-friend')}
          </Link>
        </li>
        {osType === 'mobile' && (
          <li className='w-full'>
            <Link
              to={ROUTES.CONTACT.REQUEST.SCAN.$path()}
              className='flex w-full items-center gap-2'>
              <ProfileAdd2 className='size-5' />
              {t('conversation.list.menu.join-group')}
            </Link>
          </li>
        )}
        <li className='w-full'>
          <Link
            to={ROUTES.CONTACT.GROUPS.CREATE.$path()}
            className='flex w-full items-center gap-2'>
            <CreateGroup className='size-5' />
            {t('conversation.list.menu.create-group')}
          </Link>
        </li>
      </ul>
    </details>
  );
}
